<template>
	<div
		class="g-block-divider-thin g-block-divider-padding"
		:class="{
			'g-block-divider-thin--edit': editable,
			'is-active': editable && active,
			'g-block-divider-thin--h5': h5,
			'g-block-divider-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<span
			class="g-block-divider-thin__line"
			:style="{ background: themeColor }"
			aria-hidden="true"
		></span>
	</div>
</template>

<script>
	import { dividerMixin } from '../shared/dividerMixin.js';

	export default {
		name: 'GBlockDividerThin',
		mixins: [dividerMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/dividerEditShell.less';

	.g-block-divider-thin {
		.divider-block-edit-shell();
	}

	.g-block-divider-thin__line {
		display: block;
		width: 100%;
		height: 1px;
	}

	.g-block-divider-thin--h5 {
		.g-block-divider-thin__line {
			height: 0.02rem;
		}
	}
</style>
